import React, { useContext } from 'react'
import * as _ from 'lodash-es'
import { Box } from '@chakra-ui/react'
import { CanvasDrawContext } from './CanvasDrawF'
import { Simple1Grid } from '../../Chakra3F/ChakraF.jsx'

const colorOptions = [
  '#000000', '#FFFFFF', '#7F7F7F', '#C3C3C3', '#4d2e1c', '#B97A57', '#ED1C24', '#FFAEC9', '#FF7F27', '#FFC90E',
  '#FFF200', '#fff8d9', '#22B14C', '#B5E61D', '#00A2E8', '#99D9EA', '#3F48CC', '#7092BE', '#A349A4', '#C8BFE7']

const lightColors = ['#FFFFFF', '#EFE4B0']

export const isLightColor = (color) => {
  return _.includes(lightColors, color)
}

export const ChooseColorBar = () => {
  const {activeColor, setActiveColor} = useContext(CanvasDrawContext)
  // https://wiki.vg-resource.com/Paint / 7paint

  return <Simple1Grid {...{bg: "gray", columns: colorOptions.length / 2, w: '100%', h: '100px'}}>
    {colorOptions.map((color) => {
      const onClick = () => setActiveColor(color)
      return <Box key={color} {...{onClick, bg: color}} />
    })}
  </Simple1Grid>
}